import React from 'react'
import { Button, Col, Row, ListGroup, ListGroupItem } from 'reactstrap'
import Modal from 'ui/modal'
import RelatedProducts from 'containers/purchase/partials/related_products'
import { useTranslation } from 'react-i18next'

const SummaryModal = (props) => {
  const { modal, endpoints, relatedProducts, cart, redirectUrl } = props
  const { i18n } = useTranslation()

  return (
    <Modal
      isOpen={modal}
      footer={() => (
        <>
          <Row className="g-3">
            <Col>
              <Button
                href={endpoints.products}
                color="light"
                className="w-100 text-primary py-3 text-uppercase border border-primary"
                style={{ background: 'transparent' }}
              >
                <i className="fa fa-plus-square me-2" /> {i18n.t('summary_modal.see_more_products')}
              </Button>
            </Col>

            <Col>
              <Button
                href={redirectUrl}
                color="primary"
                className="w-100 text-white fw-bold py-3 text-uppercase"
              >
                <i className="fa fa-caret-square-right me-2" /> {i18n.t('cart_summary.link_to_reservation')}
              </Button>
            </Col>
          </Row>

          <div className="mt-4">
            <RelatedProducts
              products={relatedProducts}
              url={endpoints.service}
              limitProducts={3}
              rowProps={{
                className: 'row-cols-1 row-cols-sm-2 row-cols-md-3 mt-3 justify-content-center'
              }}
            />
          </div>
        </>
      )}
      width={850}
      showCloseIcon={false}
      bodyStyle={{ padding: '35px' }}
    >
      {cart && (
        <ListGroup>
          <ListGroupItem className="bg-light fw-bold">
            <i className="fa fa-shopping-bag me-2" />
            {i18n.t('summary_module.title')}
          </ListGroupItem>

          {cart.items.map(({ id, product, total_price_label, price_display_mode }) => (
            <ListGroupItem key={id} className="d-flex justify-content-between align-items-center">
              <div>{product.title}</div>
              {price_display_mode !== 'hidden_price' && (
                <div>
                  <strong>{total_price_label}</strong>
                </div>
              )}
            </ListGroupItem>
          ))}

          <ListGroupItem color="primary" className="d-flex justify-content-between fw-bold text-primary">
            <div>{i18n.t('summary_module.total_amount')}</div>
            <div>{cart.final_price_label}</div>
          </ListGroupItem>
        </ListGroup>
      )}
    </Modal>
  )
}

export default SummaryModal